const Footer = () => {
  const isologo = require("../img/logo-footer.png").default;
  const isologo2 = require("../img/logo-footer@2x.png").default;
  const isologo3 = require("../img/logo-footer@3x.png").default;

  const instagram = require("../img/instagram-logo.png").default;
  const instagram2 = require("../img/instagram-logo@2x.png").default;
  const instagram3 = require("../img/instagram-logo@3x.png").default;

  const facebook = require("../img/facebook-logo.png").default;
  const facebook2 = require("../img/facebook-logo@2x.png").default;
  const facebook3 = require("../img/facebook-logo@3x.png").default;

  return (
    <div className="container footer">
      <div className="row upper-sections d-block d-sm-none">
        <div className="col-2">
          {" "}
          {/** Logo */}
          <div className="logo-footer">
            <img src={isologo}
                 srcSet={`${isologo2} 2x, ${isologo3} 3x`}
                 alt=""></img>
          </div>
        </div>
        <div className="right-footer-content">
          <div className="right-footer-content_group-1">
            <span className="right-footer-content_title">
              La Pinocha Chocolates
            </span>
          </div>
          <div>
            <span className="right-footer-content_bajada-de-linea">
              Nacimos en el mar. Crecimos en el bosque
            </span>
          </div>
          <div className="right-footer-content_group-2">
            <span className="contact-us-font">¡Escríbenos! </span>
            <span className="footer-message-font">Estamos para ayudarte</span>
          </div>
          <div>
            <a href="mailto:info@lapinochachocolates.com">
              <span className="contact-em">info@lapinochachocolates.com</span>
            </a>
          </div>
          <div className="follow-us">
            <div className="follow-text">
              <span>Síguenos</span>
            </div>
            <div className="footer-logo-right">
              <a
                href="https://www.instagram.com/lapinocha.es"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={instagram}
                  srcSet={`${instagram2} 2x, ${instagram3} 3x`}
                  alt=""
                  className="instagram-relleno"
                ></img>
              </a>
              <a
                href="https://es-la.facebook.com/lapinocha.es"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={facebook}
                        srcSet={`${facebook2} 2x, ${facebook3} 3x`}
                  alt=""
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer-sm d-none d-sm-block">
        <div className="row fix-padding-top-footer-top">
          <div className="col">
            <div className="d-flex flex-row float-left">
              <div className="col">
                <img
                  src={isologo}
                  srcSet={`${isologo2} 2x, ${isologo3} 3x`}
                  alt=""
                  className="float-right"
                ></img>
              </div>
              <div className="col">
                <div className="d-flex flex-column">
                  <span className="semibold-14">La Pinocha Chocolates</span>
                  <span className="regular-14">
                    Nacimos en el mar. Crecimos en el bosque
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col footer-right-sm">
            <div className="row fix-padding-escribinos">
              <div className="col d-flex flex-column">
                <span className="semibold-14">¡Escríbenos!</span>
                <span className="semibold-14">Estamos para ayudarte</span>
                <span className="regular-14">
                  <a href="mailto:info@lapinochachocolates.com">
                    <span className="contact-em">
                      info@lapinochachocolates.com
                    </span>
                  </a>
                </span>
              </div>
              <div className="col float-right">
                <div className="follow-us">
                  <div className="follow-text">
                    <span>Síguenos</span>
                  </div>
                  <div className="footer-logo-right">
                    <a
                      href="https://www.instagram.com/lapinocha.es"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={instagram}
                        srcSet={`${instagram2} 2x, ${instagram3} 3x`}
                        alt=""
                        className="instagram-relleno"
                      ></img>
                    </a>
                    <a
                      href="https://es-la.facebook.com/lapinocha.es"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={facebook}
                        srcSet={`${facebook2} 2x, ${facebook3} 3x`}
                        alt=""
                      ></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row rights">
        <span>Todos los derechos reservados {new Date().getFullYear()} <br className="d-md-none" /><span className="d-none d-md-inline"> - </span> Powered by <a href="https://woopi.es/" target="_blank" style={{color: '#fff'}}>Woopi</a></span>
      </div>
    </div>
  );
};

export default Footer;
